//  index.js
//  Project hpi
//
//  Created by Axis Maps on 4/29/2020, 4:01:01 PM
//

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./map-legend.component'),
  loading: () => null,
});
